export default __webpack_public_path__ + "static/media/placeholder7.3700b4c6.jpeg";